// Split out from use-kit-permissions.hook.ts: use-item-permissions.hook.ts needs this,
// and use-kit-permissions.hook.ts needs custody/admin checks from utils/item-permissions.ts —
// keeping it here avoids a circular import between the two hook files.
import { usePermissions } from '../use-permissions.hook';

export const canAdminKit = (permissions: ReturnType<typeof usePermissions>) =>
	permissions.useKits && permissions.hasAnyPermission('KITS_ADMIN', 'KITS_ADMIN_RESTRICTED');
